export interface FatalitiesReport {
    total: number,
    years: [],
    states: [],
    disciplines: [],
    incidentTypes: [],
    date: string
}
export interface SelectedFilter {
    name: string,
    value: string
}
export interface FilterDefinition {
    id: string,
    name: string,
    values: string[]
}
export function toQuery(selected: SelectedFilter[]) {
    let query = "";
    selected.forEach((value, key) => {
        if (!value.name || !value.value) {
            return;
        }
        query += `${value.name}=${value.value}&`;
    });
    return query;
}
export async function getFatalitiesReport(filter?: SelectedFilter[]) {
    let queryString = "?";
    if (filter && filter.length > 0) {
        filter.map((f) => {
            if (!f.value) {
                return;
            }
            queryString += `${f.name}=${f.value}&`
        });


    }
    const res = await fetch(`${process.env.REACT_APP_API_HOST}Dashboard/Fatalities${queryString}`, {
        cache: 'force-cache',
        method: "GET",
        mode: "cors"
    })
    const post: FatalitiesReport = await res.json()
   
    return post
}

export async function getFilters() {
    const res = await fetch(`${process.env.REACT_APP_API_HOST}Dashboard/Filters`, {
        cache: 'force-cache',
        method: "GET",
        mode: "cors"
    })
    const post: FilterDefinition[] = await res.json()
    
    return post
}